// Generated by tools/as3-to-ts from work/decomp/main/scripts/FWP.as (FWP.init_data_arrays, line 1627); hand-edits allowed (see docs/architecture.md)

/** `this.OBJ_DEF` literal from FWP.init_data_arrays. Returns a fresh copy on every call (the game mutates it). */
export function create_OBJ_DEF(): any {
  return {
    "obj_barrel": {
      "id": 1,
      "gold": 100,
      "diam": 1,
      "limit": 50,
      "level": 1,
      "show_shop": true,
      "gsearch_prob": "yes",
      "usable": false,
      "name": "Удлиненный ствол"
    },
    "obj_middle_clip": {
      "id": 2,
      "gold": 250,
      "diam": 1,
      "limit": 50,
      "level": 1,
      "show_shop": true,
      "gsearch_prob": "yes",
      "usable": false,
      "name": "Средняя обойма"
    },
    "obj_big_clip": {
      "id": 3,
      "gold": 1000,
      "diam": 1,
      "limit": 50,
      "level": 1,
      "show_shop": false,
      "gsearch_prob": "rare",
      "usable": false,
      "name": "Большая обойма"
    },
    "obj_small_cell": {
      "id": 4,
      "gold": 3000,
      "diam": 3,
      "limit": 50,
      "level": 1,
      "show_shop": true,
      "gsearch_prob": "yes",
      "usable": false,
      "name": "Малый элемент питания"
    },
    "obj_big_cell": {
      "id": 5,
      "gold": 6000,
      "diam": 6,
      "limit": 50,
      "level": 1,
      "show_shop": false,
      "gsearch_prob": "rare",
      "usable": false,
      "name": "Большой элемент питания"
    },
    "obj_rad_lock": {
      "id": 6,
      "gold": 10000,
      "diam": 10,
      "limit": 50,
      "level": 1,
      "show_shop": false,
      "gsearch_prob": "no",
      "usable": false,
      "name": "Радиевый затвор"
    },
    "obj_hard_jacket": {
      "id": 7,
      "gold": 11000,
      "diam": 11,
      "limit": 50,
      "level": 1,
      "show_shop": false,
      "gsearch_prob": "rare",
      "usable": false,
      "name": "Усиленная оболочка"
    },
    "obj_napalm_cont": {
      "id": 8,
      "gold": 4000,
      "diam": 4,
      "limit": 50,
      "level": 1,
      "show_shop": true,
      "gsearch_prob": "yes",
      "usable": false,
      "name": "Контейнер с напалмом"
    },
    "obj_poison_cont": {
      "id": 9,
      "gold": 6000,
      "diam": 6,
      "limit": 50,
      "level": 1,
      "show_shop": false,
      "gsearch_prob": "rare",
      "usable": false,
      "name": "Контейнер с ядом"
    },
    "obj_rad_cont": {
      "id": 10,
      "gold": 9000,
      "diam": 9,
      "limit": 50,
      "level": 1,
      "show_shop": false,
      "gsearch_prob": "no",
      "usable": false,
      "name": "Контейнер с рад. газом"
    },
    "obj_laser_mod": {
      "id": 11,
      "gold": 4000,
      "diam": 4,
      "limit": 50,
      "level": 1,
      "show_shop": true,
      "gsearch_prob": "yes",
      "usable": false,
      "name": "Лазерный модулятор"
    },
    "obj_plasma_mod": {
      "id": 12,
      "gold": 6000,
      "diam": 6,
      "limit": 50,
      "level": 1,
      "show_shop": false,
      "gsearch_prob": "yes",
      "usable": false,
      "name": "Плазменный модулятор"
    },
    "obj_coil": {
      "id": 13,
      "gold": 8000,
      "diam": 8,
      "limit": 50,
      "level": 1,
      "show_shop": false,
      "gsearch_prob": "rare",
      "usable": false,
      "name": "Катушка индуктивности"
    },
    "obj_pulse_mod": {
      "id": 14,
      "gold": 15000,
      "diam": 15,
      "limit": 50,
      "level": 1,
      "show_shop": false,
      "gsearch_prob": "no",
      "usable": false,
      "name": "Импульсный модулятор"
    },
    "obj_ultra_mod": {
      "id": 15,
      "gold": 30000,
      "diam": 30,
      "limit": 50,
      "level": 1,
      "show_shop": false,
      "gsearch_prob": "no",
      "usable": false,
      "name": "Ультраволновый преобр."
    },
    "obj_eg_generator": {
      "id": 17,
      "gold": 4000,
      "diam": 4,
      "limit": 50,
      "level": 1,
      "show_shop": false,
      "gsearch_prob": "no",
      "usable": false,
      "name": "Генератор электрогравитации"
    },
    "obj_fuel": {
      "id": 18,
      "gold": 3000,
      "diam": 3,
      "limit": 50,
      "level": 1,
      "show_shop": true,
      "gsearch_prob": "yes",
      "usable": false,
      "name": "Топливные баки"
    },
    "obj_small_expl": {
      "id": 19,
      "gold": 1500,
      "diam": 2,
      "limit": 50,
      "level": 1,
      "show_shop": true,
      "gsearch_prob": "yes",
      "usable": false,
      "name": "Усиленная взрывчатка (мал.)"
    },
    "obj_radio": {
      "id": 20,
      "gold": 3000,
      "diam": 3,
      "limit": 50,
      "level": 1,
      "show_shop": false,
      "gsearch_prob": "no",
      "usable": false,
      "name": "Радиопередатчик"
    },
    "obj_big_expl": {
      "id": 21,
      "gold": 8000,
      "diam": 8,
      "limit": 50,
      "level": 1,
      "show_shop": false,
      "gsearch_prob": "no",
      "usable": false,
      "name": "Усиленная взрывчатка (бол.)"
    },
    "obj_red_book": {
      "id": 22,
      "gold": 100000,
      "diam": 100,
      "limit": 1,
      "level": 1,
      "show_shop": false,
      "gsearch_prob": "no",
      "usable": true,
      "name": "Красная книга рецептов"
    },
    "obj_orange_book": {
      "id": 23,
      "gold": 40000,
      "diam": 40,
      "limit": 1,
      "level": 1,
      "show_shop": false,
      "gsearch_prob": "no",
      "usable": true,
      "name": "Оранж. книга рецептов"
    },
    "obj_yellow_book": {
      "id": 24,
      "gold": 75000,
      "diam": 75,
      "limit": 1,
      "level": 1,
      "show_shop": false,
      "gsearch_prob": "no",
      "usable": true,
      "name": "Желтая книга рецептов"
    },
    "obj_green_book": {
      "id": 25,
      "gold": 80000,
      "diam": 80,
      "limit": 1,
      "level": 1,
      "show_shop": false,
      "gsearch_prob": "no",
      "usable": true,
      "name": "Зеленая книга рецептов"
    },
    "obj_skyblue_book": {
      "id": 26,
      "gold": 30000,
      "diam": 30,
      "limit": 1,
      "level": 1,
      "show_shop": false,
      "gsearch_prob": "no",
      "usable": true,
      "name": "Голубая книга рецептов"
    },
    "obj_blue_book": {
      "id": 27,
      "gold": 120000,
      "diam": 120,
      "limit": 1,
      "level": 1,
      "show_shop": false,
      "gsearch_prob": "no",
      "usable": true,
      "name": "Синяя книга рецептов"
    },
    "obj_violet_book": {
      "id": 28,
      "gold": 200000,
      "diam": 200,
      "limit": 1,
      "level": 1,
      "show_shop": false,
      "gsearch_prob": "no",
      "usable": true,
      "name": "Фиолет. книга рецептов"
    },
    "obj_white_book": {
      "id": 29,
      "gold": 350000,
      "diam": 350,
      "limit": 1,
      "level": 1,
      "show_shop": false,
      "gsearch_prob": "no",
      "usable": true,
      "name": "Белая книга рецептов"
    },
    "obj_black_book": {
      "id": 30,
      "gold": 1200000,
      "diam": 1200,
      "limit": 1,
      "level": 70,
      "show_shop": false,
      "gsearch_prob": "no",
      "usable": true,
      "name": "Черная книга рецептов"
    },
    "obj_junk1": {
      "id": 31,
      "gold": 625,
      "diam": 1,
      "limit": 50,
      "level": 1,
      "show_shop": false,
      "gsearch_prob": "no",
      "usable": false,
      "name": "Сломанные детали"
    },
    "obj_junk2": {
      "id": 32,
      "gold": 625,
      "diam": 1,
      "limit": 50,
      "level": 1,
      "show_shop": false,
      "gsearch_prob": "no",
      "usable": false,
      "name": "Сломанные детали"
    },
    "obj_junk3": {
      "id": 33,
      "gold": 625,
      "diam": 1,
      "limit": 50,
      "level": 1,
      "show_shop": false,
      "gsearch_prob": "no",
      "usable": false,
      "name": "Сломанные детали"
    },
    "obj_junk4": {
      "id": 34,
      "gold": 625,
      "diam": 1,
      "limit": 50,
      "level": 1,
      "show_shop": false,
      "gsearch_prob": "no",
      "usable": false,
      "name": "Сломанные детали"
    },
    "obj_junk5": {
      "id": 35,
      "gold": 900,
      "diam": 1,
      "limit": 50,
      "level": 1,
      "show_shop": false,
      "gsearch_prob": "no",
      "usable": false,
      "name": "Сломанные детали"
    },
    "obj_junk6": {
      "id": 36,
      "gold": 900,
      "diam": 1,
      "limit": 50,
      "level": 1,
      "show_shop": false,
      "gsearch_prob": "no",
      "usable": false,
      "name": "Сломанные детали"
    },
    "obj_junk7": {
      "id": 37,
      "gold": 900,
      "diam": 1,
      "limit": 50,
      "level": 1,
      "show_shop": false,
      "gsearch_prob": "no",
      "usable": false,
      "name": "Сломанные детали"
    },
    "obj_junk8": {
      "id": 38,
      "gold": 900,
      "diam": 1,
      "limit": 50,
      "level": 1,
      "show_shop": false,
      "gsearch_prob": "no",
      "usable": false,
      "name": "Сломанные детали"
    },
    "obj_junk9": {
      "id": 39,
      "gold": 1500,
      "diam": 1,
      "limit": 50,
      "level": 1,
      "show_shop": false,
      "gsearch_prob": "no",
      "usable": false,
      "name": "Сломанные детали"
    },
    "obj_junk10": {
      "id": 40,
      "gold": 1500,
      "diam": 1,
      "limit": 50,
      "level": 1,
      "show_shop": false,
      "gsearch_prob": "no",
      "usable": false,
      "name": "Сломанные детали"
    }
  };
}
